export interface ProposeChangeRequest {
    reason?: string;
    newStartTime?: string;
    newRoomId?: string;
    autoAcceptRoomBooking: boolean;
}

export interface CancelChangeRequest {
    reason?: string;
}

export interface DeclineChangeRequest {
    reason?: string;
}

export enum RoomBookingChangeStatus {
    PENDING_REPLY = 'PENDING_REPLY',
    ACCEPTED = 'ACCEPTED',
    DECLINED = 'DECLINED',
    CANCELLED = 'CANCELLED',
    EXPIRED = 'EXPIRED'
}

export interface RoomBookingChangeProposal {
    id: string;
    roomBookingId: string;
    oldStartTime: string;
    newStartTime: string;
    oldRoomId: string;
    newRoomId: string;
    newRoomName: string;
    status: RoomBookingChangeStatus;
    /**
     * Optional reason/comment provided by host when proposing a change.
     * Backend payloads may use different field names depending on version.
     */
    proposalReason?: string | null;
    reason?: string | null;
    replyComment?: string | null;
    autoAcceptRoomBooking: boolean;
    createdAt: string;
    updatedAt: string;
    active: boolean;
}